export default {"src":"/_next/static/media/Ultimate-badge.28eb1974.svg","height":68,"width":68};